import React from 'react';
import HeroSectionML from '../components/sections/HeroSectionML';
import SEOHead from '../components/common/SEOHead';

const TestMultilingual = () => {
  return (
    <div>
      <SEOHead
        titlePT="Grupo BMP | Soluções Empresariais Premium"
        titleEN="Grupo BMP | Premium Business Solutions"
        descriptionPT="Arquitetura Empresarial, Operações & Gestão Internacional de Projetos em Dubai, Angola e mercados globais."
        descriptionEN="Global Trading Solutions, Arquitetura Empresarial, Operações & Gestão Internacional de Projetos, Petróleo & Gás across Dubai, Angola, and global markets."
      />
      
      <HeroSectionML />
      
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-4">Sistema Multilíngue Funcionando!</h2>
          <p className="text-gray-600">
            Use o language switcher no header para alternar entre PT e EN.
            O conteúdo é carregado dinamicamente do backend.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TestMultilingual;
